// extracted by mini-css-extract-plugin
export default {"TextContainer":"Container_TextContainer__BWmhy","VideoContainer":"Container_VideoContainer__zB05p"};